<template>
  <div class="Home" v-scroll="handleScroll">
    <site-navbar />
    <div class="page-content">
      <div class="page-body">
        <div class="artists-container">
          <div class="artists-header">
            <h3>Galleries</h3>
            <p>
              Explore curated masterpieces in our galleries, connecting various
              artists and enthusiasts.
            </p>
          </div>
          <div class="on-phone-search on-sm">
            <div class="search">
              <div class="form">
                <i class="fa-solid fa-search"></i>
                <input type="text" placeholder="Artist Name" />
              </div>
              <div class="filter">
                <i class="fa-solid fa-filter"></i>
                <p>Filter</p>
              </div>
            </div>
          </div>
          <div class="gallery-items-list">
            <router-link
              :to="{
                name: 'ViewGallery',
                params: {
                  id: item.gallery_id,
                  name: $urlCompatible(item.gallery_name_eng),
                },
              }"
              class="artist-item"
              v-for="item in items"
              :key="item.gallery_id"
            >
              <gallery-card :item="item" />
            </router-link>
          </div>
          <div class="loader" v-if="isLoading">
            <img :src="$img('loader.png')" alt="" class="load-img" />
          </div>
        </div>

        <pagination
          class="pagination"
          :totalItems="allResults.length"
          :itemsPerPage="itemsPerPage"
          :itemCount="false"
          @pageChanged="
            (page) => {
              changePage(page);
            }
          "
        />
      </div>
      <gallery-filter
        class="on-lg"
        @filterData="
          (data) => {
            filterData = data;
          }
        "
      />
    </div>
    <site-footer />
  </div>
</template>

<script>
export default {
  data() {
    return {
      allItems: [
        {
          id: 1,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/300/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/600/600",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/600/600",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/400/400",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/500",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/500/500",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/100/100",
              },
            },
          ],
        },
        {
          id: 2,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/200",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
          ],
        },
        {
          id: 3,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/700/700",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/500/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/300/500",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/600/500",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
          ],
        },
        {
          id: 4,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/200/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
          ],
        },
        {
          id: 5,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
          ],
        },
        {
          id: 6,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
          ],
        },
        {
          id: 7,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/600/500",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
          ],
        },
        {
          id: 8,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
          ],
        },
        {
          id: 1,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/300/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/600/600",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/600/600",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/400/400",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/500",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/500/500",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/100/100",
              },
            },
          ],
        },
        {
          id: 2,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/200",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
          ],
        },
        {
          id: 3,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/700/700",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/500/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/300/500",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/600/500",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
          ],
        },
        {
          id: 4,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
          ],
        },
        {
          id: 5,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
          ],
        },
        {
          id: 6,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
          ],
        },
        {
          id: 7,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
          ],
        },
        {
          id: 8,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
          ],
        },
        {
          id: 1,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/300/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/600/600",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/600/600",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/400/400",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/500",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/500/500",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/100/100",
              },
            },
          ],
        },
        {
          id: 2,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/200",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
          ],
        },
        {
          id: 3,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/700/700",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/500/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/300/500",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/600/500",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
          ],
        },
        {
          id: 4,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
          ],
        },
        {
          id: 5,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
          ],
        },
        {
          id: 6,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
          ],
        },
        {
          id: 7,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
          ],
        },
        {
          id: 8,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
          ],
        },
        {
          id: 1,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/300/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/600/600",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/600/600",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/400/400",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/500",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/500/500",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/100/100",
              },
            },
          ],
        },
        {
          id: 2,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/200",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
          ],
        },
        {
          id: 3,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/700/700",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/500/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/300/500",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/600/500",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
          ],
        },
        {
          id: 4,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/200/300",
              },
            },
          ],
        },
        {
          id: 5,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
          ],
        },
        {
          id: 6,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
          ],
        },
        {
          id: 7,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
          ],
        },
        {
          id: 8,
          name: "Indabo Gallery",
          category: ["Photography", "Drawings"],
          image: "https://picsum.photos/200/300",
          location: "Rwanda",
          art: [
            {
              id: 1,
              name: "Art 1",
              image: "https://picsum.photos/300/300",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 2,
              name: "Art 2",
              image: "https://picsum.photos/100/100",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 3,
              name: "Art 3",
              image: "https://picsum.photos/400/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 4,
              name: "Art 4",
              image: "https://picsum.photos/500/400",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
            {
              id: 5,
              name: "Art 5",
              image: "https://picsum.photos/100/200",
              price: 1000,
              owner: {
                name: "Indabo Gallery",
                image: "https://picsum.photos/300/300",
              },
            },
          ],
        },
      ],
      allResults: [],
      items: [],
      current_index: 0,
      isLoading: false,
      viewPopup: false,
      selectedItem: null,
      currentPage: 1,
      itemsPerPage: 21,
      filterData: {
        gallery_name_eng: "",
        address_eng: "",
        selectedCategory: "All",
      },
    };
  },
  methods: {
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop
          ) +
            window.innerHeight >=
          document.documentElement.offsetHeight - 800;

        if (bottomOfWindow) {
          if (this.allItems.length != 0) {
            setTimeout(() => {
              this.items.push(
                ...this.allItems.splice(0, this.current_index + 10)
              );
              this.current_index = this.current_index + 10;
            }, 1000);
          } else {
            setTimeout(() => {
              console.log("done");
              this.isLoading = false;
            }, 1000);
          }
        }
      };
    },
    closeView() {
      this.viewPopup = false;
      document.body.style.overflowY = "auto";
    },
    openArtWork(item) {
      this.$router.push({
        name: "ViewArtWork",
        params: { id: item.id, name: item.name },
      });
    },
    getItems() {
      this.$startLoader();
      this.$store
        .dispatch("GET_GALLERIES", {
          data: this.newItem,
          token: this.$getToken(),
        })
        .then((res) => {
          this.$stopLoader();
          this.allItems = res.data;
          this.allResults = res.data;
          this.changePage(1);
        })
        .catch((err) => {
          this.$stopLoader();
          if (err.response.status == 400) {
            err.response.data.errors.forEach((error) => {
              this.$notify({
                type: "error",
                title: "Something went wrong",
                text: error.msg,
              });
            });
          }
          if (err.response.status == 401) {
            this.$notify({
              type: "error",
              title: "Authentication failed",
              text: err.response.data.message,
            });
            this.$router.push({ name: "AdminLogin" });
          }
        });
    },

    filterNow() {
      let results1 = [...this.allItems];
      let results2 = [];
      if (this.filterData.gallery_name_eng != "") {
        results2 = results1.filter((item) => {
          return (
            item.gallery_name_eng
              .toLowerCase()
              .includes(this.filterData.gallery_name_eng.toLowerCase()) ||
            item.gallery_name_kor
              .toLowerCase()
              .includes(this.filterData.gallery_name_eng.toLowerCase())
          );
        });
      } else {
        results2 = results1;
      }

      // address_eng

      let results3 = [];
      if (this.filterData.address_eng != "") {
        results3 = results2.filter((item) => {
          return (
            item.address_eng
              .toLowerCase()
              .includes(this.filterData.address_eng.toLowerCase()) ||
            item.address_kor
              .toLowerCase()
              .includes(this.filterData.address_eng.toLowerCase())
          );
        });
      } else {
        results3 = results2;
      }
      let results4 = [];
      if (this.filterData.selectedCategory != "All") {
        results4 = results3.filter((item) => {
          return item.gallery_name_eng
            .toLowerCase()
            .startsWith(this.filterData.selectedCategory.toLowerCase());
        });
      } else {
        results4 = results3;
      }

      this.allResults = results4;

      this.currentPage = 1;
      this.changePage(1);
    },
    changePage(page) {
      this.currentPage = page;
      this.items = this.$changePage(this.allResults, page, this.itemsPerPage);
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.getItems();
    // this.scroll();
  },
  watch: {
    filterData: {
      handler: function (val) {
        this.filterNow();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/main.scss";
.Home {
  .page-content {
    display: flex;
    padding: 1rem 5rem;
    @media screen and (max-width: 1500px) {
      padding: 1rem 5rem;
    }
    @media screen and (max-width: 1100px) {
      padding: 1rem 5rem;
    }
    @media screen and (max-width: 850px) {
      padding: 1rem 1rem;
    }
    .page-body {
      width: calc(100% - 300px);
      padding-top: 2rem;
      @media screen and (max-width: 1500px) {
        width: calc(100% - 250px);
      }
      @media screen and (max-width: 850px) {
        padding-top: 0rem;
        width: 100%;
      }
      .artists-container {
        .artists-header {
          h3 {
            color: #000000;
            font-size: 3rem;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            @media screen and (max-width: 1500px) {
              font-size: 2rem;
            }
            @media screen and (max-width: 1100px) {
              font-size: 27px;
            }
            @media screen and (max-width: 850px) {
              font-size: 24px;
              font-weight: 500;
              margin-bottom: 1rem;
            }
          }
          p {
            color: #333;
            font-size: 1.6rem;
            margin-top: 1rem;
            margin-bottom: 2rem;
            @media screen and (max-width: 1500px) {
              margin-top: 0.2rem;
              font-size: 1rem;
            }
            @media screen and (max-width: 1100px) {
              font-size: 1.3rem;
            }
            @media screen and (max-width: 850px) {
              font-size: 1rem;
            }
          }
        }
        .on-phone-search {
          display: none;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem;
          column-gap: 10px;
          @media screen and (max-width: 850px) {
            padding: 1rem;
            padding-left: 0px;
          }
          .search {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            .form {
              input {
                width: 100%;
                padding: 0.5rem 1rem;
                border: 1px #adadad solid;
                border-radius: 5px;
                font-size: 1.25rem;
                padding-left: 2.5rem;
                @media screen and (max-width: 1100px) {
                  font-size: 1rem;
                }
                @media screen and (max-width: 850px) {
                  font-size: 0.9rem;
                }
              }
              i {
                color: #adadad;
                font-size: 1.25rem;
                position: absolute;
                top: 50%;
                left: 1rem;
                transform: translateY(-50%);

                @media screen and (max-width: 1100px) {
                  font-size: 1rem;
                }
                @media screen and (max-width: 850px) {
                  font-size: 0.9rem;
                }
              }
            }
          }
          .filter {
            display: flex;
            justify-content: center;
            align-items: center;
            column-gap: 5px;
            background: $blue;
            color: #fff;
            padding: 10px 1.5rem;
            border-radius: 500px;
            position: relative;
            i {
              color: #fff;
              position: relative;
              font-size: 1.25rem;
              @media screen and (max-width: 1100px) {
                font-size: 1rem;
              }
              @media screen and (max-width: 850px) {
                font-size: 0.9rem;
              }
            }
          }
        }
        .loader {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 3rem 0;
          img {
            -webkit-animation: spin 1s linear infinite;
            -moz-animation: spin 1s linear infinite;
            animation: spin 1s linear infinite;
            width: 50px;
            @media screen and (max-width: 1500px) {
            }
          }
          @-moz-keyframes spin {
            100% {
              -moz-transform: rotate(360deg);
            }
          }
          @-webkit-keyframes spin {
            100% {
              -webkit-transform: rotate(360deg);
            }
          }
          @keyframes spin {
            100% {
              -webkit-transform: rotate(360deg);
              transform: rotate(360deg);
            }
          }
        }
      }
    }
  }
}
</style>